import { useEffect } from "react";
import { useLanderConfig } from "../commons/ConfigContext";
import { sendErrorEvent } from "../commons/LanderEvent";
import { ErrorCode, System } from "../commons/Constants";
import { LanderConfig } from "../types/LanderConfig";

export const rsocRedirect = async (landerConfig: LanderConfig) => {
  const rsocUrl = new URL(
    landerConfig.rsoc.path,
    "https://www.searchhounds.com"
  );

  // Query params that will be used in searchhounds
  rsocUrl.searchParams.set("psystem", landerConfig.system);
  rsocUrl.searchParams.set("domain", window.location.hostname);
  if (landerConfig.adSense.keywords) {
    rsocUrl.searchParams.set("terms", landerConfig.adSense.keywords.join(","));
  }

  try {
    location.assign(rsocUrl.toString());
  } catch (error) {
    sendErrorEvent(landerConfig, ErrorCode.ERROR_RSOC_REDIRECT);
  }
};

export function useRsoc() {
  const { landerConfig } = useLanderConfig();

  const rsocRedirectEnabled =
    !!landerConfig.rsoc?.path &&
    (landerConfig.system === System.PARKWEB ||
      landerConfig.lander.feedID === 1) &&
    landerConfig.domain?.rootDomain !== "cloudynest.store"; // This domain was reported by Google for paid traffic. This is a temporary fix until we find a better way to detect paid traffic.

  useEffect(() => {
    if (rsocRedirectEnabled) rsocRedirect(landerConfig);
  }, [rsocRedirectEnabled, landerConfig]);

  return { rsocRedirectEnabled };
}
